import { render, staticRenderFns } from "./product-filter.vue?vue&type=template&id=3a9c34a4&scoped=true"
import script from "./product-filter.vue?vue&type=script&lang=js"
export * from "./product-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9c34a4",
  null
  
)

export default component.exports